// JavaScript code for acf_blocks/team-members-block component
(($) => {

    "use strict";
    if ($('.acf-blocks-team-members-block').length === 0) {
        return;
    }
    console.log("acf_blocks/team-members-block scripts loaded...");

    $('.acf-blocks-team-members-block .read-more-btn').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).closest('div').next('.read-more-content').slideToggle();
    });

})(jQuery);